module.exports = __webpack_public_path__ + "static/media/avatar.2bdd4706.jpg";